import { IntercomComponent } from "src/app/components/features/intercom/intercom.component";
import { ExternalScriptsComponent } from "src/app/components/features/external-scripts/external-scripts.component";
import { GoogleTagManagerComponent } from "src/app/components/features/google-tag-manager/google-tag-manager.component";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from "@angular/common/http";
import { AppConfig } from "src/app/app.config";
import { AdminisSharedModule } from "src/app/components/shared/adminis-shared.module";
import { ModalModule } from "src/app/components/modal/modal.module";
import { RootStoreModule } from "src/app/store/root-store.module";
import { RoutesModule } from "src/app/routes/routes.module";
import { AppComponent } from "src/app/app.component";
import { RootServiceModule } from "src/app/services/root-services.module";
import { environment } from "src/environments/environment";
import { RaygunErrorHandler } from "./services/raygun/raygun-error-handler";
import {AuthCallbackComponent} from "./universal-login/components/auth-callback.component";


export function initializeApp(appConfig: AppConfig) {
        
    if (AppConfig.checkUrlOverride()) {
        return () => appConfig.loadConfig(environment.appName);
    }

    if (!environment.production && environment.appName) {
        return () => appConfig.loadConfig(environment.appName);
    } else {
        return () => appConfig.loadConfig();
    } 
}

@NgModule({
    declarations: [AppComponent, ExternalScriptsComponent, GoogleTagManagerComponent, IntercomComponent],
    imports: [
        RoutesModule,
        RouterModule,
        ModalModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AdminisSharedModule,
        RootServiceModule,
        RootStoreModule.forRoot(),
        AuthCallbackComponent
    ],
    providers: [
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppConfig],
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: RaygunErrorHandler,
        },
        { 
            provide: APP_BASE_HREF, 
            // APP_BASE_HREF does not support a Promise<string> so cant execute a normal factory method
            // There are probably nicer ways of doing this but this works as a V1.
            useFactory: () => { AppConfig.checkUrlOverride(); return AppConfig.baseHref; },
        }  
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
